export enum Environment {
    Production,
    Staging,
    Experimental,
    Local
}

export const CurrentEnvironment: Environment = 
    location.hostname.includes("localhost") ? Environment.Local : 
    location.hostname.includes("internal") ? Environment.Staging :
    location.hostname.includes("experimental") ? Environment.Experimental :
    Environment.Production;

export const BASE_PATH = (CurrentEnvironment === Environment.Production ? import.meta.env.VITE_APIBASEPATH_PROD : 
        (CurrentEnvironment === Environment.Experimental ? import.meta.env.VITE_APIBASEPATH_EXPERIMENTAL : import.meta.env.VITE_APIBASEPATH_DEV)) || "";